import isObject from './shared/isObject';

function createStorageAbstraction(storage: Storage, keyPrefix: string) {
  let objectRootKey = 'value';
  return {
    set(key: string, value: unknown) {
      let string = JSON.stringify({ [objectRootKey]: value });
      storage.setItem(keyPrefix + ':' + key, string);
    },

    get(key: string) {
      let string = storage.getItem(keyPrefix + ':' + key);
      if (typeof string === 'string') {
        let value = tryParse(string);
        return isObject(value) ? value[objectRootKey] : undefined;
      }
    },

    delete(key: string) {
      storage.removeItem(keyPrefix + ':' + key);
    },
  };
}

function tryParse(input: string): JSONValue {
  try {
    return JSON.parse(input);
  } catch (_error) {
    return null;
  }
}

export default createStorageAbstraction(sessionStorage, 'app');
